import './BaseEnvironmentBar.scss';

export const BaseEnvironmentBar = () => {
  let allowedEnv = ['local', 'stage', 'test'];
  let environment = import.meta.env.VITE_ENV || null;

  return (
    <div className="environment-bar">
      {environment && allowedEnv.includes(environment) && (
        <p className="copy copy--color-dark">Environment: {environment}</p>
      )}
    </div>
  );
};
